import type { RedeemHook } from './types/redeem.type';
import { BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { useRedeemV1 } from './v1';
import { useRedeemV2 } from './v2';

interface UseRedeem extends RedeemHook, BaseHookResult {}

export const useRedeem = createVersionedHook<UseRedeem>(
  {
    v1: useRedeemV1,
    v2: useRedeemV2,
  },
  'useRedeem',
);
